import { FORMAT_TIME } from "./format-time";
import { tabKeys } from "./tab-keys";
import { TABLE_FIELD_TYPE } from "./table-field-type";
import {
  LOAI_PHIEU_KHO,
  TT_PHIEU_KHO,
  LOAI_FORM,
  TT_THUOC,
  TT_VTYT,
} from "./pharmacy-store";
import { TT_PHIEU_VTYT, LOAI_PHIEU_VTYT } from "./medical-supplies-store";
import { LOAI_DON_THUOC } from "./medicine-store";
import { TT_PHIEU_KHAM } from "./examination";
import { TT_DON_KINH } from "./glass";
import { TEN_PHONG } from "./catalog";
import { CURRENCY_LOCALE } from "./currency";
enum FIELD_TYPE {
  DATE = "DATE",
  INPUT = "INPUT",
  COMBO_BOX_ADD = "COMBO_BOX_ADD",
  INPUT_NUMBER = "INPUT_NUMBER",
  INPUT_PASSWORD = "INPUT_PASSWORD",
  SELECT = "SELECT",
  SELECT_MULTI = "SELECT_MULTI",
  CHECKBOX = "CHECKBOX",
  LIST = "LIST",
  RADIO = "RADIO",
  RADIO_VN = "RADIO_VN",
  RADIO_BUTTON = "RADIO_BUTTON",
  COLOR = "COLOR",
  NUMBER = "NUMBER",
  AUTO_COMPLETE = "AUTO_COMPLETE",
  CURRENCY = "CURRENCY",
  CODE = "CODE",
  COMBO_BOX = "COMBO_BOX",
  TEXT_AREA = "TEXT_AREA",
  TIME = "TIME",
  BUTTON = "BUTTON",
  TRA_THUOC = "TRA_THUOC",
  ICON = "ICON",
  RADIO_CUSTOM = "RADIO_CUSTOM",
  DATE_PRE = "DATE_PRE",
  DATE_ON = "DATE_ON",
  DATE_DISABLE = "DATE_DISABLE",
  DATE_DISABLE_NO_DAY = "DATE_DISABLE_NO_DAY",
  NORMAL_CHECKBOX = "NORMAL_CHECKBOX",
  NORMAL_CHECKBOX_NONE = "NORMAL_CHECKBOX_NONE",
  DATE_DAY_INPUT = "DATE_DAY_INPUT",
  MONTH = "MONTH",
  TEXTT_AREA_CUSTOM = "TEXTT_AREA_CUSTOM",
  CURRENCY_NEGATIVE = "CURRENCY_NEGATIVE",
}
export {
  FIELD_TYPE,
  TABLE_FIELD_TYPE,
  LOAI_DON_THUOC,
  FORMAT_TIME,
  tabKeys,
  LOAI_PHIEU_KHO,
  TT_PHIEU_KHO,
  LOAI_FORM,
  TT_THUOC,
  TT_VTYT,
  TT_PHIEU_VTYT,
  LOAI_PHIEU_VTYT,
  TT_PHIEU_KHAM,
  TT_DON_KINH,
  TEN_PHONG,
  CURRENCY_LOCALE,
};
